import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import {
	headerMobileImageOverlayGradient,
	headerTitleAreaBackground,
} from '#src/app/pages/petitionDetails/shared/utilities';
import { AfterMediaWaypoint } from '#src/app/pages/petitionDetails/shared/waypoints';

import { PetitionStarterInHeaderMobile } from '../components/PetitionStarterInHeaderMobile';
import { usePhoto } from '../hooks/photo';
import { useFirstMovement } from '../hooks/useFirstMovement';

import { MediaContainer } from './MediaSunrise';
import { MovementContainer } from './Movement';

export const HeadingContainerMobile: React.FC = () => {
	const photo = usePhoto();
	const averageColor = photo?.palette?.averageColor;

	const firstMovement = useFirstMovement();
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const {
		data: { petitionPageStarterInHeaderExperimentEnabled },
	} = usePetitionDetailsPageUserData();
	const { user, organization, createdAt, createdAtLocalized } = petition;
	const title: string = petition.displayTitle;

	return (
		<div data-testid="heading-container-mobile" data-qa="heading-container-mobile">
			<div className="block [@media(min-width:768px)]:hidden">
				<div
					className="relative w-full overflow-hidden"
					style={{ backgroundColor: headerTitleAreaBackground(averageColor) }}
				>
					<div className="w-full">
						<div className="relative w-full">
							{!!photo && <MediaContainer key={petition.id} photo={photo} />}
							<AfterMediaWaypoint />
							<div
								className="pointer-events-none absolute inset-0 bg-blend-multiply"
								style={{ backgroundImage: headerMobileImageOverlayGradient(averageColor) }}
								aria-hidden
							/>
						</div>
						<div
							className="relative z-10 flex flex-col items-start space-y-2 pt-2 pr-8 pb-[60px] pl-8"
							style={{ backgroundColor: headerTitleAreaBackground(averageColor) }}
						>
							<div className="mt-[-11px] mb-4 h-[10.6px] w-[91.4px] bg-[#E5231E]" />
							<Text
								data-qa="petition-title-mobile"
								variant="heading"
								as="h1"
								size="x-large"
								className="max-w-[700px] text-xl leading-tight font-bold text-wrap text-white"
							>
								{title}
							</Text>
							<PetitionStarterInHeaderMobile
								user={user}
								organization={organization}
								createdAt={createdAt}
								createdAtLocalized={createdAtLocalized}
								petitionPageStarterInHeaderEnabled={petitionPageStarterInHeaderExperimentEnabled}
							/>
						</div>
						<div className="absolute bottom-[-7px] z-13 h-[32px] w-full rounded-lg bg-white" />
					</div>
				</div>
			</div>

			{firstMovement && (
				<div className="mb-4 px-4 sm:mb-2 sm:px-0">
					<MovementContainer movement={firstMovement} alwaysExpanded={!photo} />
				</div>
			)}
		</div>
	);
};
